export const PURCHASE_ORDER_FILTER_KEY_OBJ = {
  'PONum': 'po_num',
  'VendorID': 'vendor_num',
  'VendorName': 'vendor_name',
  'container_num': 'container_num',
  'Purchaser_User_Name': 'Purchaser_User_Name',
}

export const AP_PURCHASE_ORDER_FILTER_KEY_OBJ = {
  'PONum': 'po_num',
  'shipnote': 'shipnote',
  'VendorName': 'vendor_name',
  'container_num': 'container_num',
  'PurchaseStatus': 'PurchaseStatus',
  'Boln': 'boln',
  'Vessel': 'Vessel',
  'ShipTo': 'shipto',
  'Purchaser_User_Name': 'purchaser',
  'create_user_name': 'purchaser',
  'modify_user_name': 'modifier',
}

export const SALES_ORDER_SORT_KEY_OBJ = {
  'CreateTime': 'MODIFIDE',
  'SONum': 'SONO',
  'InvoiceNum': 'INVOICENO',
  'PONum': 'CPO',
  'Deliver_Customer_num': 'CUSTNO',
  'Deliver_CustomerName': 'CUSTNAME',
  'Description': 'DESCRIPTION',
  'discountDisplay': 'DISCOUNT',
  'PromoCode': 'PROMOCODE',
  'FinalPrice': 'FINAL',
  'FinalNetWeight': 'TOTALWT',
  'Modifier_User_Name': 'MODIFIER',
  'Sales_User_Name': 'SALES',
  'Picker_User_Name': 'PICKER',
  'AdditionalOrder': 'ADDITIONALORDER',
  'SaleStatus': 'STATUS',
  'IsUnderBuffer': 'UNDERBUFFER',
  'OrderDateDisplay': 'ORDERDE',
  'DispatchDate': 'ESTDELEVERY',
  'ShipmentDate': 'SHIPPED',
}

export const PURCHASE_ORDER_SORT_KEY_OBJ = {
  'PONum': 'PONO',
  'VendorID': 'VENDORNO',
  'VendorName': 'VENDORNAME',
  'container_num': 'CONTAINERNUM',
  'fob_point': 'FOBPOINT',
  'FinalPrice': 'FINAL',
  'OrderDate': 'ORDERED',
  'ETADate': 'ETADATE',
  'ShipTo': 'SHIPTO',
  'PurchaseStatus': 'STATUS',
  'ReceivedDate': 'RECEIVEDATE',
  'Dropship': 'DS',
  'Purchaser_User_Name': 'PURCHASER',
  'ShippingCost': 'SHIP',
  'MiscCost': 'MISC',
}

export const RECEIVE_HISTORY_SORT_KEY_OBJ = {
  'PONum': 'PONO',
  'WarehouseReceiveNum': 'RECEIVENO',
  'WarehouseName': 'WAREHOUSE',
  'InvoiceNum': 'VENDORINVOICE',
  'VendorName': 'VENDOR',
  'PurchaseFinalPrice': 'POFINAL',
  'FinalPrice': 'RECEIVEFINAL',
  'InvoiceFinalPrice': 'INVOICEFINAL',
  'InvoiceStatus': 'INVOICESTATUS',
  'ArrivalStatus': 'ARRIVALSTATUS',
  'PaymentStatus': 'PAYMENTSTATUS',
  'PostingDate': 'RECEIVEDATE',
  'Create_Username': 'CREATEDBY',
  'Modify_Username': 'MODIFY',
  'container_num': 'CONTAINERNO',
  'Owner': 'OWNER',
  'Note': 'NOTE',
}



// WEBPACK FOOTER //
// ./master/jsx/utils/map.js